module.exports = __webpack_public_path__ + "media/assets/icons/viber-acfdcabb574d5e316340fa1a4836ff09.svg";